// src/pages/Help/HelpNoticeDetail.jsx
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HelpAside from "../components/HelpAside";
import axios from "axios";
import { FiChevronLeft } from "react-icons/fi";
import wizMarket from  "../../../assets/image/home/wizMarketLogo.png"

const formatDate = (dateString) => {
    const d = new Date(dateString);
    if (isNaN(d)) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
};

const HelpNoticeDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { notice_no } = useParams();

    const [notice, setNotice] = useState(location.state?.notice || null);
    const [loading, setLoading] = useState(!location.state?.notice);
    const [err, setErr] = useState("");

    const fetchById = useCallback(async () => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice/${notice_no}`
            );
            if (!data || data.notice_no == null) {
                setErr("공지사항을 찾을 수 없습니다.");
                return;
            }
            setNotice(data);
        } catch (e) {
            console.error(e);
            setErr("공지사항을 불러오는 데 실패했습니다.");
        } finally {
            setLoading(false);
        }
    }, [notice_no]);

    useEffect(() => {
        if (!notice) {
            setLoading(true);
            fetchById();
        }
    }, [notice, fetchById]);

    const goList = () => navigate("/help/notice");

    return (
        <div className="min-h-screen bg-white">
            <header className="max-w-6xl mx-auto top-0 z-50">
                <div className="h-15 px-5 py-3 flex items-center justify-between">
                    <a href="/" className="flex items-center gap-2 pl-6">
                        <img src={wizMarket} alt="wizMarket" className="h-8 w-auto" />
                        <p style={{fontFamily: "SonsieOne"}}>wiz Market</p>
                    </a>
                    <div className="flex items-center gap-2">
                        <a href="../"className="px-8 py-2 inline-flex items-center rounded-md bg-black/10 text-lg hover:bg-black/30">
                            고객센터
                        </a>
                        {/* <div className="px-4 py-2 inline-flex items-center text-white rounded-md bg-[#7864F9]/60 text-lg font-medium hover:bg-[#7864F9]">
                            로그인/회원가입
                        </div> */}
                    </div>
                </div>
            </header>
            <div className="max-w-6xl mx-auto px-6 grid grid-cols-12 gap-8 pt-8">
                {/* 좌측 사이드 */}
                <HelpAside activeKey="notice" />

                {/* 메인 */}
                <main className="col-span-12 lg:col-span-9">
                    {!loading && err && (
                        <div className="space-y-4">
                            <div className="rounded-lg bg-red-50 text-red-700 px-3 py-2 text-sm">{err}</div>
                            <button
                                onClick={goList}
                                className="rounded-lg border px-4 py-2 text-sm hover:bg-gray-50"
                            >
                                목록
                            </button>
                        </div>
                    )}

                    {!loading && !err && notice && (
                        <>
                            <div className="flex items-center justify-between mb-6">
                                <button
                                    onClick={goList}
                                    className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
                                >
                                    <FiChevronLeft /> 목록으로
                                </button>
                                <span className="text-sm text-gray-400">
                                    {formatDate(notice.created_at)}
                                </span>
                            </div>

                            <h1 className="text-2xl font-extrabold tracking-tight pb-4">
                                {notice.notice_title}
                            </h1>

                            <div className="prose max-w-none text-gray-700 whitespace-pre-line pb-8">
                                {notice.notice_content}
                            </div>

                            <p className="text-gray-400 text-sm">
                                등록일: {formatDate(notice.created_at)}
                            </p>
                        </>
                    )}
                </main>
            </div>
        </div>
    );
};

export default HelpNoticeDetail;
